const translations = {
  "en": {
    "x": "x"
  },
  "zh-tw": {
    "x": "x"
  }
};

export default translations;
